import axios from '../../helpers/axios-setup';

export const unImpersonate = () => axios.post('/staff/impersonate/logout');
